<ion-content style="text-align: center;">
  <img class="logo" src="assets/imgs/logo/shopachat.png">
  <br>
  <span>{{ 'Landing.LineEN' | translate }}</span>
  <br>
    <span style="color:chocolate" (click)="goToTerms('en')">Terms of use </span>and <span style="color:chocolate" (click)="goToPolicies('en')">confidentiality</span>
  <br> <br>
  <span>{{ 'Landing.LineFR' | translate }}</span>
  <br>
  <span style="color:chocolate"  (click)="goToTerms('fr')">Termes</span> et <span style="color:chocolate" (click)="goToPolicies('fr')">politiques de confidentialités</span>
  <br> <br>
  
</ion-content>